import { loadReportBuilder } from './report-builder/report-builder.js';
import { handleFormError } from 'assets/js/misc';

angular.module('logbook')
  .controller('report-editor', ['$scope', '$rootScope', '$http', '$location', '$q', '$timeout', '$interval', 'reportService', 'logService', 'reportMapping', 'uiGridConstants', 'batchRequest', 'errorHandler', '$filter', 'reportBuilderService', '$uibModal', 'primeNGHelpersService',
      function($scope, $rootScope, $http, $location, $q, $timeout, $interval, reportService, logService, reportMapping, uiGridConstants, batchRequest, errorHandler, $filter, reportBuilderService, $uibModal, primeNGHelpersService) {
	
		  // https://webpack.js.org/guides/code-splitting/#dynamic-imports

		//   import(/* webpackChunkName: "angular-ui-grid" */ 'angular-ui-grid');
		//   // Required by angular-ui-grid for drag and drop support
		//   import(/* webpackChunkName: "angular-ui-grid" */ 'ui-grid-draggable-rows');
		// //   import(/* webpackChunkName: "angular-ui-grid" */'angular-ui-grid/ui-grid.css');
		//   import('angular-ui-grid/ui-grid.css'); // TODO: Test these *****************************************
	
	      var $builder;
	      
          $scope.changesMade = false;
          
          $scope.schedulers = [];

          $scope.upperOutputGridOptions = {
              enableSorting: false,
              useUiGridDraggableRowsHandle: true,
              headerTemplate: 'custom-output-header.html',
              rowTemplate: 'draggable-row.html',
              enableHorizontalScrollbar: uiGridConstants.scrollbars.NEVER,
              enableVerticalScrollbar: uiGridConstants.scrollbars.NEVER,
              minRowsToShow: 0,
              columnDefs: [
                  {
                      field: 'handle',
                      displayName: '',
                      enableColumnMenu: false,
                      cellTemplate: 'drag-handle.html',
                      width: 30
                  },
                  {
                      field: 'name',
                      displayName: 'Field',
                      enableColumnMenu: false,
                      cellTemplate: 'row-label-more.html'
                  },
                  {
                      field: 'label',
                      displayName: 'Label',
                      enableColumnMenu: false,
                      cellTemplate: 'custom-label.html',
                      width: 250
                  },
                  {
                      field: 'delete',
                      displayName: '',
                      enableColumnMenu: false,
                      cellTemplate: 'delete-output-row.html',
                      width: 30
                  }
              ],
              data: [],

              onRegisterApi: function(gridApi) {
                  $scope.upperOutputGridApi = gridApi;
                  gridApi.draggableRows.on.rowDropped($scope, function () {
                      $scope.updateChangeStatus(true);
                  });
              }
          };
          $scope.lowerOutputGridOptions = {
              enableRowSelection: true,
              enableFiltering: true,
              multiSelect: true,
              columnDefs: [
                  {
                      field: 'name',
                      displayName: 'Available Fields',
                      enableHiding: false,
                      enableColumnMenu: false,
                      headerCellClass: 'text-center'
                  }
              ],
              headerRowHeight: 62,
              rowTemplate: 'row.html',
              enableHorizontalScrollbar: uiGridConstants.scrollbars.NEVER,
              enableVerticalScrollbar: uiGridConstants.scrollbars.NEVER,
              data: [
                  { name: 'Note Timeframe', noteField: 17, initiallyHidden: false, useTagStyle: false },
                  { name: 'Note Date/Time', noteField: 6, initiallyHidden: false, useTagStyle: false },
                  { name: 'Carry Forward End Time', noteField: 16, initiallyHidden: false, useTagStyle: false },
                  { name: 'Update Date/Time', noteField: 4, initiallyHidden: false, useTagStyle: false },
                  { name: 'Note Creation Date/Time', noteField: 2, initiallyHidden: false, useTagStyle: false },
                  { name: 'Note', noteField: 7, initiallyHidden: false, useTagStyle: true },
                  { name: 'Template', noteField: 14, initiallyHidden: false, useTagStyle: false },
                  { name: 'Tags', noteField: 10, initiallyHidden: false, useTagStyle: false },
                  { name: 'Created By', noteField: 3, initiallyHidden: false, useTagStyle: false },
                  { name: 'Updated By', noteField: 5, initiallyHidden: false, useTagStyle: false },
                  { name: 'Turnover', noteField: 8, initiallyHidden: false, useTagStyle: false },
                  { name: 'Carry Forward', noteField: 15, initiallyHidden: false, useTagStyle: false },
                  { name: 'Attachments', noteField: 13, initiallyHidden: false, useTagStyle: false },
                  { name: 'Comments', noteField: 12, initiallyHidden: false, useTagStyle: false },
                  { name: 'Note ID', noteField: 1, initiallyHidden: false, useTagStyle: false },
                  { name: 'Priority', noteField: 18, initiallyHidden: false, useTagStyle: false }
              ],

              onRegisterApi: function(gridApi) {
                  $scope.lowerOutputGridApi = gridApi;

                  function updateOutputGrid(row) {
                      var field = row.entity,
                          matchingFields = $scope.upperOutputGridOptions.data.filter(function(element) {
                              return element.hasOwnProperty('noteField') ?
                                  element.noteField === field.noteField :
                                  element.id === field.id;
                          });

                      delete field.$$hashKey;

                      if (row.isSelected && !matchingFields.length) {
                          $scope.upperOutputGridOptions.data.push(field);
                      }
                      else if (!row.isSelected && matchingFields.length) {
                          $scope.upperOutputGridOptions.data = $scope.upperOutputGridOptions.data.filter(function(element) {
                              return element.hasOwnProperty('noteField') ?
                                  element.noteField !== field.noteField :
                                  element.id !== field.id;
                          });
                      }
                  }

                  gridApi.selection.on.rowSelectionChanged($scope, function(row) {
                      updateOutputGrid(row);

                      toggleGridVertScrollbar($scope.upperOutputGridApi);

                      $scope.updateChangeStatus(true);
                  });

                  gridApi.selection.on.rowSelectionChangedBatch($scope, function(rows) {
                      rows.forEach(function(row) {
                          updateOutputGrid(row);
                      });

                      toggleGridVertScrollbar($scope.upperOutputGridApi);
                  });
              }
          };

          $scope.upperAccessGridOptions = {
            useUiGridDraggableRowsHandle: true,
            rowTemplate: 'row.html',
            enableHorizontalScrollbar: uiGridConstants.scrollbars.NEVER,
            enableVerticalScrollbar: uiGridConstants.scrollbars.NEVER,
            minRowsToShow: 0,
            columnDefs: [
                {
                    field: 'name',
                    displayName: 'User',
                    enableColumnMenu: false,
                    enableSorting: true
                },
                {
                    field: 'access',
                    displayName: 'Access',
                    enableColumnMenu: false,
                    enableSorting: false,
                    cellTemplate: 'custom-access.html',
                    width: 250
                },
                {
                    field: 'delete',
                    displayName: '',
                    enableColumnMenu: false,
                    cellTemplate: 'delete-access-row.html',
                    width: 30
                }
            ],
            data: [],

            onRegisterApi: function(gridApi) {
                $scope.upperAccessGridApi = gridApi;
            }
        };
        
        $scope.userAccessGridDefer = $q.defer();
        
        $scope.lowerAccessGridOptions = {
            enableRowSelection: true,
            enableFiltering: true,
            multiSelect: true,
            columnDefs: [
                {
                    field: 'name',
                    displayName: 'Available Users',
                    enableColumnMenu: false,
                    headerCellClass: 'text-center'
                }
            ],
            headerRowHeight: 62,
            rowTemplate: 'row.html',
            enableHorizontalScrollbar: uiGridConstants.scrollbars.NEVER,
            enableVerticalScrollbar: uiGridConstants.scrollbars.NEVER,
            data: [],

            onRegisterApi: function(gridApi) {
                $scope.lowerAccessGridApi = gridApi;

                 var updateAccessGrid = $scope.updateAccessGrid = function(row){
                    var user = row.entity,
                        matchingUsers = $scope.upperAccessGridOptions.data.filter(function(element) {
                            return element.id === user.id;
                        });

                    delete user.$$hashKey;

                    if (row.isSelected && !matchingUsers.length) {
                        if (!user.access) user.access = 'none';
                        $scope.upperAccessGridOptions.data.push(user);
                    }
                    else if (!row.isSelected && matchingUsers.length) {
                        $scope.upperAccessGridOptions.data = $scope.upperAccessGridOptions.data.filter(function(element) {
                            return element.id !== user.id;
                        });
                    }
                    
                    toggleGridVertScrollbar($scope.upperAccessGridApi);
                };

                gridApi.selection.on.rowSelectionChanged($scope, function(row) {
                    updateAccessGrid(row);

                    $scope.updateChangeStatus(true);
                });

                gridApi.selection.on.rowSelectionChangedBatch($scope, function(rows) {
                    rows.forEach(function(row) {
                        updateAccessGrid(row);
                    });

                    toggleGridVertScrollbar($scope.upperAccessGridApi);
                });
            }
        };

      $scope.saveOutput = function(resolve, reject) {
         $http.patch('api/reports/' + $scope.report.id, {
             primarySort: null,
             secondarySort: null
         }).then(function() {
            $http.get('api/reportViewEntries', {
                params: {
                   report: $scope.report.id
                }
             }).then(function (response) {
                 var existingEntries = response.data._embedded.reportViewEntries,
                     newEntries = $scope.upperOutputGridOptions.data.map(function(e, i) {
                        return {
                         noteField: e.noteField ? '/api/noteFields/' + e.noteField : null,
                         templateSegment: e.id ? '/api/templateSegments/' + e.id : null,
                         name: e.label ? e.label : null,
                         report: '/api/reports/' + $scope.report.id,
                         newMarker: true,
                         useTagStyle: e.useTagStyle || false,
                         initiallyHidden: e.initiallyHidden || false
                        }
                     }),
                     requests = [];
                 
                 newEntries.forEach(function (rve) {
                    requests.push(batchRequest.req('POST', '/api/reportViewEntries', rve));
                 });

                 batchRequest.all(requests).then(function() {
                    $http.get('api/reportViewEntries', {
                        params: {
                           report: $scope.report.id
                        }
                     }).then(function(response) {
                         saveChangedFormControls(response.data._embedded.reportViewEntries).then(function() {
                            resolve();
                         }).catch(function() {
                             reject();
                         });
                     }).catch(function() {
                         reject();
                     });
                 }).catch(function() {
                     reject();
                 });
             }).catch(function() {
                 reject();
             });
         }).catch(function() {
             reject();
         });
      };

      $scope.deleteReportViewEntry = function(rve) {
        var requests = [],
            primarySortId = $scope.report.primarySort ? $scope.report.primarySort.id : null,
            secondarySortId = $scope.report.secondarySort ? $scope.report.secondarySort.id : null,
            deletePrimary = false,
            deleteSecondary = false;

        rve.forEach(function (entry) {
            if (entry.id === primarySortId)
                deletePrimary = true;
            if (entry.id === secondarySortId)
                deleteSecondary = true;

            requests.push(batchRequest.req('DELETE', '/api/reportViewEntries/' + entry.id));
        });

        if (deletePrimary || deleteSecondary) {
            var patch = {};
            if (deletePrimary) 
                patch.primarySort = null;
            if (deleteSecondary)
                patch.secondarySort = null;

            requests.unshift(batchRequest.req('PATCH', '/api/reports/' + $scope.report.id, patch));
        }

        return batchRequest.all(requests);
      };

      $scope.saveAccess = function(resolve, reject) {
        
        $http.get('/api/reports', {
            params: {
                id: $scope.report.id
            }
        })
            .then(function(results)
            {
                if (!results.data._embedded.reports.length)
                    reject();
                
                results = results.data._embedded.reports[0].users.map(function(reportUser)
                {
                    return reportUser.user;
                });
                var requests = $scope.upperAccessGridOptions.data.filter(function(logUser)
                    {
                        return -1 === results.findIndex(function(rLogUser)
                        {
                            return rLogUser.id === logUser.id;
                        })
                    })
                    .map(function(e)
                    {
                        var role = e.access === 'edit' ? 2 : e.access === 'run' ? 1 : null;
                        var toPost = {
                            report: '/api/reports/' + $scope.report.id,
                            user: '/api/logUsers/' + e.id,
                            role: role ? '/api/logRoles/' + role : null
                        };
                        return batchRequest.req('POST', '/api/reportUsers', toPost);
                    });
                requests.push(batchRequest.req('PATCH',
                    '/api/reports/' + $scope.report.id,
                    {
                        defaultRole: ($scope.report.defaultAccess && $scope.report.defaultAccess !== 'none')
                            ? '/api/logRoles/' + $scope.report.defaultAccess
                            : null
                    }));
                batchRequest.all(requests).then(function () {
                    resolve();
                }).catch(function() {
                    reject();
                });
            })
            .catch(function()
            {
                reject();
            })
        
     };

      $scope.updateOutput = function(templateId) {
        $http.get('api/reportViewEntries', {
            params: {
                  'report': $scope.report.id,
                  'sort': 'sortOrder'
            }
        }).then(function (response) {
            $scope.reportViewEntries = response.data._embedded.reportViewEntries;

            $scope.upperOutputGridOptions.data = $scope.upperOutputGridOptions.data.filter(function(field) {
                return field.noteField;
            });

            $scope.lowerOutputGridOptions.data = $scope.lowerOutputGridOptions.data.filter(function(element) {
                return !element.id && element.id !== 0;
            });

            $scope.refreshReport(true).then(function (reportResponse) {
                $scope.report = reportResponse.data;
                if (templateId === undefined) {
                    if ($scope.report.template) {
                        $http.get('api/templateSegments', {
                            params: {
                                'template': $scope.report.template.id,
                                'sort': 'sortOrder',
                                'size': 10000
                            }
                        }).then(function(tsResponse) {
                            $scope.templateSegments = tsResponse.data._embedded.templateSegments;
                            loadOutputGrids(false, $scope.templateSegments, $scope.subTemplate);
                        });
                    } else {
                        $scope.templateSegments = null;
                        loadOutputGrids(false, $scope.templateSegments, $scope.subTemplate);
                    } 
                } else {
                    if (templateId === 'Default (All Notes)') {
                        loadOutputGrids(false, null, $scope.subTemplate);
                    } else {
                        $http.get('api/templateSegments', {
                            params: {
                                'template': templateId,
                                'sort': 'sortOrder',
                                'size': 10000
                            }
                        }).then(function(tsResponse) {
                            $scope.templateSegments = tsResponse.data._embedded.templateSegments;
                            loadOutputGrids(false, tsResponse.data._embedded.templateSegments, $scope.subTemplate);
                        });
                    }
                }
            });
        });
      };

      $scope.removeOutputRow = function(row) {
         if ($scope.userHasEdit) {
            var field = row.entity;

            delete field.$$hashKey;

            $scope.upperOutputGridOptions.data = $scope.upperOutputGridOptions.data.filter(function (element) {
               return field.noteField ?
                  element.noteField !== field.noteField :
                  element.id !== field.id;
            });

            var lowerField = $scope.lowerOutputGridOptions.data.find(function (element) {
               return field.noteField ? element.noteField === field.noteField : element.id === field.id;
            });

            if (lowerField && lowerField.label)
               delete lowerField.label;

            $scope.lowerOutputGridApi.selection.toggleRowSelection(lowerField);
         }
      };
    
      /**
       * Called by ng-click on selecting column setting dropdown item
       * @param row
       * @param event
       */
      $scope.setColumnSettingEvent = function(row, event)
      {
        var $target = $(event.target);
        
        $target.toggleClass('checked');
        row.entity[$target.attr('setting')] = $target.hasClass('checked');
        $scope.updateChangeStatus(true);
      };

      $scope.removeAccessRow = function(row) {
        if ($scope.userHasEdit || $scope.userIsAdmin) {
           var user = row.entity;

           delete user.$$hashKey;

           $scope.upperAccessGridOptions.data = $scope.upperAccessGridOptions.data.filter(function (element) {
              return element.id !== user.user.id;
           });

           var lowerUser = $scope.lowerAccessGridOptions.data.find(function (element) {
              return element.id === user.id;
           });
        
           delete lowerUser.access;

           $scope.lowerAccessGridApi.selection.toggleRowSelection(lowerUser);
        }
     };

     $scope.cleanSelfHref = function(node, field)
     {
        if( node[field] && node[field]._links )
           node[field]._links.self.href = node[field]._links.self.href.replace(/{.*}/,'');
     };
     
     $scope.cleanReportHrefs = function() {
        ['outputType','primarySort','secondarySort','defaultRole'].forEach(function(f) {
           $scope.cleanSelfHref($scope.report, f);
        });
        $scope.report.users && $scope.report.users.forEach(function(user) {
           user._links.self.href = user._links.self.href.replace(/{.*}/,'');
           if(user.role) 
              user.role._links.self.href = user.role._links.self.href.replace(/{.*}/,'');
        });
     };
     
     logService.getLogRoles().subscribe(logRoles => {
		$scope.accessOptions = [];
		
        logRoles.forEach(role => {
           if( role.id == 1 )
			  $scope.accessOptions.push({"label":"Run","value":role._links.self.href});
           else if( role.id == 2)
              $scope.accessOptions.push({"label":"Run and Edit","value":role._links.self.href});
        });
     });
     
     $scope.newUsers = [];
     
     $scope.getRoleDisplayName = function(role)
     {
        if( !role || !role._links.self.href )
           return 'None';
        if( role.id == 2)
           return 'Run and Edit';
        return 'Run';
     };
    
      /**
       * Gets the draft version of the current report from its complex object ID
       * @param {Number|String=} complexId - Complex Object ID to use to get draft of. Defaults to current scope's.
       * @return {*}
       */
      $scope.getDraftVersion = function(complexId)
      {
          complexId = parseInt(complexId);
          complexId = !isNaN(complexId)
              ? complexId
              : ($scope.report && $scope.report.complexObject)
                  ? $scope.report.complexObject.id
                  : undefined;
    
          return $q(function(resolve, reject)
          {
              if (complexId)
                  resolve($http.get('/api/reports', {
                      noErrorPopup: true,
                      params: {
                          isDraft: true,
                          saveInProgress: false,
                          'complexObject.id': complexId
                      }
                  })
                      .then(function(results)
                      {
                          return results.data._embedded.reports[0];
                      }, reject));
              else
                  resolve(undefined)
          });
      };
    
      /**
       * Gets the current revision of the current report from its complex object ID
       * @param {Number|String=} complexId - Complex Object ID to use to get active revision of. Defaults to current scope's.
       * @return {*}
       */
      $scope.getActiveRevision = function(complexId)
      {
          complexId = parseInt(complexId);
          complexId = !isNaN(complexId)
              ? complexId
              : ($scope.report && $scope.report.complexObject)
                  ? $scope.report.complexObject.id
                  : undefined;
          
          return $q(function(resolve, reject)
          {
              if (complexId)
                  resolve($http.get('/api/reports', {
                      noErrorPopup: true,
                      params: {
                          'complexObject.id': complexId,
                          activeRevision: true
                      }
                  })
                      .then(function(results)
                      {
                          return results.data._embedded.reports[0];
                      }, reject));
              else
                  resolve(undefined);
          });
      };
     
     $scope.refreshReport = function(skipReportControls)
     {
         $scope.usersWithAccess = {};
         var reportDraft = {
             "saveInProgress": true,
             "name": $filter('date')(new Date(), 'yyyy-MM-dd HH:mm'),
             "advancedMode": null,
             "primarySortDescending": null,
             "secondarySortDescending": null,
             "lastRun": null,
             "queryBuilderJson": null,
             "runOnLoad": null,
             "pageSize": null,
             "noteReturnLimit": null,
             "showObsoleteSegments": null,
             "autoRefreshSeconds": null,
             "defaultMenuBarItem": false,
             "defaultViewNotesFilter": false,
             "templateTrigger": false,
             "outputType": {
                 "description": "Default",
                 "name": "Default",
                 "id": 1,
                 "sortOrder": null,
                 "_links": {
                     "self": {
                         "href": "http://174.131.178.229:45321/api/reportOutputTypes/1",
                         "templated": true
                     }
                 }
             },
             "subTemplate": null,
             "template": null,
             "defaultRole": null,
             "logId": $scope.selectedLog.id,
             "primarySort": null,
             "secondarySort": null,
             "users": []
         };
        var deferred = $q.defer();
        $q(function(resolve, reject)
        {
            var reportId = $location.search()['report'];
            var complexId = $location.search()['draft'];
            
            if (reportId)
            {
                $location.search('draft', undefined).replace();
                resolve($http.get('/api/reports/' + reportId, {
                    noErrorPopup: true,
                    params: {
                        'projection': 'reportProjection'
                    }
                }))
            }
            else if (complexId)
            {
                $q.all([$scope.getDraftVersion(complexId), $scope.getActiveRevision(complexId)])
                    .then(function(results)
                    {
                        var report = results[0] || results[1] || undefined;
                        
                        if (report)
                            resolve({ data: report });
                        
                        else
                            reject();
                    })
            }
            else {
                // If the report is a draft, set the active log user as able to edit
                $scope.usersWithAccess[$scope.selectedLog.activeLogUser.id] = { id: 2 };
                $scope.userAccessGridDefer.promise
                    .then(function()
                    {
                        // Set the active log user in the report access grids
                        var row = $scope.lowerAccessGridApi.grid.rows.find(function(row)
                        {
                            return row.entity.id === $scope.selectedLog.activeLogUser.id;
                        });
                        
                        if (!row)
                            return;
                        
                        row.isSelected = true;
                        row.entity.access = 'edit';
                        $scope.updateAccessGrid(row);
                    });
                resolve({ data: reportDraft })
            }
        })
        .then(function(result) {
           $scope.schedulers.forEach(function(x){ x.report = result.data.complexObject })
           $scope.report = result.data;
           $scope.getReportSchedules();
           $scope.getDraftVersion()
               .then(function(draft)
               {
                   $scope.draft = draft;
               });
           $scope.cleanReportHrefs();
           $scope.report.users.forEach(function(u) {
              $scope.usersWithAccess[u.user.id] = u.role;
           });
           var currentUserId = $rootScope.selectedLog.activeLogUser.id;
           $scope.userIsAdmin = $rootScope.selectedLog.activeLogUser.role.name == 'Admin';
           $scope.userHasEdit = $scope.usersWithAccess.hasOwnProperty(currentUserId) ?
                                       $scope.usersWithAccess[currentUserId] && $scope.usersWithAccess[currentUserId].id === 2 :
                                       $scope.report.defaultRole && $scope.report.defaultRole.id === 2;
           if (!skipReportControls)
           {
            $scope.report.defaultAccess = !$scope.report.defaultRole ? 'none' : $scope.report.defaultRole.id === 1 ? '1' : '2';
            
            $scope.reportControls = {
                name: $scope.report.name,
                outputType: $scope.report.outputType._links.self.href,
                primarySort: $scope.report.primarySort ?
                    $scope.report.primarySort.templateSegment ?
                        $scope.report.primarySort.templateSegment._links.self.href.replace('{?projection}', '') :
                        $scope.report.primarySort.noteField.id :
                    null,
                primarySortDescending: $scope.report.primarySortDescending,
                secondarySort: $scope.report.secondarySort ?
                    $scope.report.secondarySort.templateSegment ?
                        $scope.report.secondarySort.templateSegment._links.self.href.replace('{?projection}', '') :
                        $scope.report.secondarySort.noteField.id :
                    null,
                secondarySortDescending: $scope.report.secondarySortDescending,
                runOnLoad: $scope.report.runOnLoad,
                pageSize: $scope.report.pageSize ? $scope.report.pageSize.toString() : "10",
                noteReturnLimit: $scope.report.noteReturnLimit ? $scope.report.noteReturnLimit : 500,
                showObsoleteSegments: $scope.report.showObsoleteSegments || false,
                autoRefreshSeconds: ($scope.report.autoRefreshSeconds || 0).toString(),
                defaultViewNotesFilter: !!$scope.report.defaultViewNotesFilter || false,
                defaultMenuBarItem: !!$scope.report.defaultMenuBarItem || false
                };
            
            $('#show-obsolete').prop('checked', $scope.reportControls.showObsoleteSegments);
            }

           deferred.resolve(result);
        }, function(error) {
           deferred.reject(error);
        });
        return deferred.promise;
     };

     $scope.doShowNewUser = function() {
        $scope.showNewUser = true;
        $scope.newUser = {};
        $scope.newUserForm.$show();
     };
     $scope.doHideNewUser = function() {
        $scope.showNewUser = false;
        delete $scope.newUser;
     };
     $scope.updateNewUserField = function(field, $data) {
        $scope.newUser[field] = $data;
        return true;
     };
     $scope.addUserAccess = function() {
        var deferred = $q.defer();
        $scope.newUser['report'] = $scope.report._links.self.href;
        $http.post('/api/reportUsers', $scope.newUser, {
           'rawError': true,
           'noErrorPopup': true
        }).then(
           function(result) {
              $scope.doHideNewUser();
              $scope.refreshReport().then(function() {
                 deferred.resolve(result);
              });
           },
           function(error) {
              handleFormError(deferred, $scope.newUserForm, error);
           });
        return deferred.promise;
     };
     
     $scope.removeUserAccess = function(user) {
        return $http.delete(user._links.self.href).then($scope.refreshReport);
     };
     
     $scope.updateAccess = function(user, $data) {
        return $http.patch(user._links.self.href, {'role': $data}).then($scope.refreshReport);
     };
     $scope.newUserFilter = function(user) {
        return !$scope.usersWithAccess[user.id];
     };

     var defer = $q.defer();
     $scope.getReportData = defer.promise;

     $q.all([
         $scope.refreshReport()
             .catch(function(e)
             {
                 errorHandler.handle('Error during initial report load.', JSON.stringify(e), false);
                 $location.url('/report-manager').replace();
                 return $q.reject();
             }),
         $http.get('/api/logUsers', {
             params: {
                 'log': $scope.selectedLog.id
             }
         })
     ]).then(function(results) {
         $scope.report = results[0].data;
         $scope.logUsers = results[1].data._embedded.logUsers;

         var promises = {
             reportFields: $q(function(resolve)
             {
                 if ($scope.report.id)
                     resolve($http.get('api/reportFields', {
                         params: {
                             'report': $scope.report.id
                         }
                     }));
                 else
                     resolve({data: { _embedded: { reportFields: []}}})
             }),
             templateSegments: $scope.report.template ?
                 $http.get('api/templateSegments', {
                     params: {
                         'template': $scope.report.template.id,
                         'sort': 'sortOrder',
                         'size': 10000
                     }
                 }) : null,
             reportViewEntries: $q(function(resolve)
             {
                 if ($scope.report.id)
                     resolve($http.get('api/reportViewEntries', {
                         params: {
                             'report': $scope.report.id,
                             'sort': 'sortOrder'
                         }
                     }));
                 else
                     resolve(resolve({data: { _embedded: { reportViewEntries: []}}}))
             }),
             templates:
                $http.get('api/templates', {
                    params: {
                        logOrGlobal: $scope.selectedLog.id,
                        projection: 'templateProjectionWithSubTemplates'
                    }
                })
         };

         $q.all(promises).then(function(results) {
             $scope.reportViewEntries = results.reportViewEntries.data._embedded.reportViewEntries;
             $scope.subTemplate = $scope.report.subTemplate;
             
             var reportData = {
                 subTemplate: $scope.report.subTemplate,
                 reportFields: results.reportFields.data._embedded.reportFields
             };
             
             if (results.templates)
                 $scope.templates = results.templates.data._embedded.templates;

             if (results.templateSegments)
             {
                 $scope.templateSegments = results.templateSegments.data._embedded.templateSegments;

                 reportData.templateId = $scope.report.template.id;
                 reportData.templateName = $scope.report.template.name;
                 reportData.templateType = $scope.report.template.templateType.name;
                 reportData.templateSegments = $scope.templateSegments.slice(0, $scope.templateSegments.length);
             }

             defer.resolve(reportData);
             
             loadOutputGrids(true, $scope.templateSegments, $scope.report.subTemplate);
             loadAccessGrids();
         });
     }).catch(function(e){
         defer.reject(e);
     });
    
      /**
       * Filters templateSegments based on sub template id
       * @param {array} segments
       * @param {number|{id:number}} subTemplateId
       * @param {boolean=false} emptyOnNoSub - Indicates whether to return an empty list on no sub template ID
       * @returns {[]|Array}
       */
      $scope.filterFromSubTemplate = function (segments, subTemplateId, emptyOnNoSub)
      {
          emptyOnNoSub = emptyOnNoSub || false;
          subTemplateId = (!isNaN(subTemplateId)) ? subTemplateId : ((subTemplateId && subTemplateId.id) ? subTemplateId.id : null );
          var startIndex = segments.findIndex(function(seg) { return seg.id == subTemplateId });
          if (!subTemplateId || (startIndex < 0)) return (emptyOnNoSub) ? [] : segments;
    
          var toReturn = [];
          for (var i = startIndex + 1; i < segments.length; i++)
          {
              var segment = segments[i];
              if (!segment || segment.type.id == 5)
                  break;
        
              toReturn.push(segment);
          }
          return toReturn;
      };
     
     function loadOutputGrids(blockChanges, templateSegments, subTemplateId)
     {
         subTemplateId = (!isNaN(subTemplateId)) ? subTemplateId : ((subTemplateId && subTemplateId.id) ? subTemplateId.id : null );
         if ((templateSegments === undefined && $scope.templateSegments) || templateSegments)
         {
             var ts = templateSegments ? templateSegments : $scope.templateSegments;
             ts = ((subTemplateId) ? $scope.filterFromSubTemplate(ts, subTemplateId) : ts)
                 .filter(function(segment)
                 {
                     if (!segment.hasOwnProperty('obsolete') || segment.obsolete === false) return true;
                     return (segment.obsolete && $scope.reportControls.showObsoleteSegments)
                 });
             
             ts.forEach(function(segment)
             {
                 var toSend = Object.assign({}, segment);
                 toSend.name = segment.longName + (($scope.reportControls.showObsoleteSegments)
                     ? ((segment.obsolete) ? ' (Removed)' : '')
                     : '');
                 
                 if (!['Literal Text', 'Sub Template', 'Tag'].includes(segment.type.name))
                     $scope.lowerOutputGridOptions.data.push(toSend);
             });
         }

         toggleGridVertScrollbar($scope.lowerOutputGridApi);
         
        $interval(function() {
            if (blockChanges) {
                $scope.reportViewEntries.forEach(function(rve) {
                    for (var i = 0; i < $scope.lowerOutputGridOptions.data.length; i++) {
                        var element = $scope.lowerOutputGridOptions.data[i];

                        if (rve.noteField ? element.noteField === rve.noteField.id : element.id === rve.templateSegment.id) {
                            element.initiallyHidden = rve.initiallyHidden || false;
                            element.useTagStyle = rve.useTagStyle || false;
                            $scope.lowerOutputGridApi.selection.selectRow(element);
                            
                            if (rve.name && $scope.upperOutputGridOptions.data.length)
                                $scope.upperOutputGridOptions.data[$scope.upperOutputGridOptions.data.length - 1].label = rve.name;
                            break;
                        }
                    }
                });
            }
            else {
                $scope.upperOutputGridOptions.data.forEach(function(row) {
                    $scope.lowerOutputGridApi.selection.selectRow(row);
                });
            }
        }, 0, 1);
     }

     function loadAccessGrids(logUsers) {
      if ($scope.logUsers) {
          $scope.logUsers.forEach(function(user) {
            user.name = user.user.firstName + ' ' + user.user.lastName;

            $scope.lowerAccessGridOptions.data.push(user);
          });
      }

      toggleGridVertScrollbar($scope.lowerAccessGridApi);

      $interval(function() {
          if ($scope.report.users.length) {
            $scope.report.users.forEach(function(user) {
                  for (var i = 0; i < $scope.lowerAccessGridOptions.data.length; i++) {
                      var element = $scope.lowerAccessGridOptions.data[i];

                      if (element.id === user.user.id) {
                          if (!user.role) element.access = 'none';
                          else if (user.role.id === 2) element.access = 'edit';
                          else if (user.role.id === 1) element.access = 'run';
                          $scope.lowerAccessGridApi.selection.selectRow(element);
                          break;
                      }
                  }
              });
              $scope.updateChangeStatus(false);
          }
          $scope.userAccessGridDefer.resolve();
      }, 0, 1);
  }

     function toggleGridVertScrollbar(gridApi) {
         var gridOptions = gridApi.grid.options;

         gridOptions.minRowsToShow = Math.min(10, gridOptions.data.length);

         var showVerticalScrollbar = gridOptions.data.length > 10;

         gridOptions.enableVerticalScrollbar = showVerticalScrollbar?
             uiGridConstants.scrollbars.ALWAYS :
             uiGridConstants.scrollbars.NEVER;

         gridApi.grid.scrollbarWidth = showVerticalScrollbar ? 15 : 0;
     }

     function saveChangedFormControls(reportViewEntries) {
         var patchField = {};

         for (var field in $scope.reportControls) {
             var selectedValue = $scope.reportControls[field];
             
             if (field === 'autoRefreshSeconds')
             {
                 selectedValue = parseInt(selectedValue);
                 if (selectedValue < 10) selectedValue = null;
	             patchField[field] = selectedValue;
                 continue;
             }
             
             if (field === 'pageSize' || field === 'noteReturnLimit')
             {
	             selectedValue = parseInt(selectedValue);
	             var minLimit = (field === 'noteReturnLimit') ? 25 : 10;
	             if (selectedValue < minLimit || selectedValue === null || isNaN(selectedValue))
	                 selectedValue = minLimit;
             }
             
             if (selectedValue && typeof selectedValue !== 'boolean' && !isNaN(selectedValue) && !['pageSize', 'noteReturnLimit'].includes(field))
                 selectedValue = '/api/noteFields/' + selectedValue;

             if (selectedValue && (field === 'primarySort' || field === 'secondarySort')) {
                 selectedValue = reportViewEntries.find(function(element) {
                     var viewEntryField = element.noteField || element.templateSegment;

                     return viewEntryField._links.self.href.includes(selectedValue);
                 })._links.self.href;
             }

             patchField[field] = selectedValue;
         }

         return $http.patch('/api/reports/' + $scope.report.id, patchField);
     }

	 reportService.getOutputTypes().subscribe(outputTypes => {
		$scope.reportOutputTypes = outputTypes.map(outputType => {
            if (outputType.description == 'Default') 
                outputType.description = 'Notes View';
            else if (outputType.description == 'Custom Tabular View')
                outputType.description = 'Table View';
            else if (outputType.description == 'Custom Chart View')
				outputType.description = 'Chart View';
			
            return outputType;
        });
	 });
		  
     $scope.isRealField = function(field) {
        return !field.newMarker;
     };

     $scope.updateChangeStatus = function(status) {
         if (!$scope.userHasEdit && !$scope.userIsAdmin)
         {
             $scope.changesMade = false;
             return;
         }
         
         $scope.changesMade = $scope.schedulersReady() && (status || $scope.report.isDraft);
         return $timeout();
     };
    
      /**
       * Presents a modal asking for a comment on publish and returns a promise to be resolved with the comment
       * @return {*}
       */
     $scope.requestComment = function()
     {
         var commentDefer = $q.defer();
         
         if ($scope.publishingComment && $scope.publishingComment.defer)
             $scope.publishingComment.defer.reject();
             
         $scope.publishingComment = {
             defer: commentDefer,
             promise: commentDefer.promise,
             text: ''
         };
         
         $('#publishCommentModal').modal('show');
         
         return commentDefer.promise
             .then(function(result)
             {
                 if (typeof result === 'string')
                     result = result.slice(0, 250);
                 
                 $('#publishCommentModal').modal('hide');
                 return result;
             }, function()
             {
                 $('#publishCommentModal').modal('hide');
                 return $q.reject();
             })
     };
    
      /**
       * Presents the Newer Draft overwrite modal and returns a promise to be resolved by dismissing the modal
       * @return {*}
       */
     $scope.presentNewerDraftModal = function()
     {
         var defer = $q.defer();
         
         if ($scope.draftModalController && typeof $scope.draftModalController.reject === 'function')
             $scope.draftModalController.reject();
         
         $scope.draftModalController = {
             promise: defer.promise,
             resolve: defer.resolve,
             reject: defer.reject
         };
    
         $('#newerDraftModal').modal('show');
         
         return defer.promise
             .then(function(resolvedWith)
             {
                 $('#newerDraftModal').modal('hide');
                 return resolvedWith
                 
             }, function()
             {
                 $('#newerDraftModal').modal('hide');
                 return $q.reject();
             })
     };
     
     $scope.redirectToView = function(viewType)
     {
         if (!$scope.report.id)
             return;
         
         var params = { view: undefined };
         switch(viewType)
         {
             case 'notes': params.view = 'Notes';
                 break;
             
             case 'chart': params.view = 'Chart';
                break;
                
             case 'table': params.view = 'Table';
                break;
         }
         
         var cParams = $location.search();
         
         $location.url('/report-view')
             .search('report-view', params.view)
             .search('latest', cParams['draft'] ? $scope.report.complexObject.id : undefined)
             .search('draft', $scope.report.isDraft || undefined)
             .search('report', $scope.report.id)
     };
    
     $scope.saveSchedules = function(complexObjectToSet)
     {
         return batchRequest.all($scope.schedulers
             .map(function(schScope){
                 if (complexObjectToSet)
                     schScope.report = complexObjectToSet;
                 return schScope.save(true)
             })
             .filter(function(saveConfig){ return !!saveConfig }));
     }
     
     $scope.saveReport = function(asDraft, bypassComment) {
         
         if (!$('#builder').queryBuilder('getRules')) {
             $('#noRulesModal').modal({backdrop: 'static'});
             return;
         }
         
         function onReject(error)
         {
             $('#savingModal').modal('hide');
             $scope.updateChangeStatus(true);
             return $q.reject(error);
         }
         
         let verificationDefer = $q.defer();
         $q.all($scope.schedulers.map(scheduler => scheduler.getVerificationPromise()))
             .finally(() => {
                 if ($scope.schedulersSavable())
                 {
                     verificationDefer.resolve();
                     return;
                 }
                 $uibModal.open({
                     backdrop: 'static',
                     template:
                     '<div class="modal-content">' +
                        '<div class="modal-body text-center">' +
                            '<h4>There is an issue with the current schedules.</h4>' +
                            '<h4> Please resolve the issue and try again.</h4>' +
                         '</div>' +
                         '<div class="modal-footer">' +
                            '<button class="btn btn-primary" ng-click="$close()">Dismiss</button>' +
                         '</div> ' +
                     '</div>'
                 });
                 verificationDefer.reject();
             });
         
             verificationDefer.promise.then(() =>
                 // If specified to be publishing with comment, request a comment modal.
                 $q.when(!asDraft && !bypassComment ? $scope.requestComment() : undefined))
                 .then(function(comment)
                 {
                     $('#savingModal').modal({backdrop: 'static', keyboard: false}, 'show');
                     return $scope.getDraftVersion()
                         .then(function(draft)
                         {
                             if (!draft || ($scope.report.id && draft.id === $scope.report.id))
                                 return comment;
                
                             // If a newer draft is found, request a overwrite modal
                             $('#savingModal').modal('hide');
                             return $scope.presentNewerDraftModal()
                                 .then(function()
                                 {
                                     return comment;
                        
                                 }, function()
                                 {
                                     return $q.reject();
                                 })
                         })
                 }, onReject)
                 .then(function(comment)
                 {
                     $('#savingModal').modal({backdrop: 'static', keyboard: false}, 'show');
                     return $http.post('/api/reports', {
                         'log': $scope.selectedLog._links.self.href,
                         'outputType': '/api/reportOutputTypes/1',
                         'name': $scope.report.name,
                         saveInProgress: true,
                         complexObject: ($scope.report.complexObject) ? $scope.report.complexObject._links.self.href : null,
                         published: null,
                         activeRevision: false,
                         defaultMenuBarItem: $scope.report.defaultMenuBarItem,
                         defaultViewNotesFilter: $scope.report.defaultViewNotesFilter
                     })
                         .then(function(result) {
                             //Hold original ID
                             $scope.report.originalId = $scope.report.id;
                
                             //Set scope report ID to be the copied ID
                             $scope.report.id = result.data.id;
                
                             return $q(function(resolve, reject)
                             {
                                 $scope.saveCriteria(resolve, reject);
                             })
                                 .then(function()
                                 {
                                     return $q(function(resolve, reject)
                                     {
                                         $scope.saveOutput(resolve, reject)
                                     })
                                 }, onReject)
                                 .then(function()
                                 {
                                     return $q(function(resolve, reject)
                                     {
                                         $scope.saveAccess(resolve, reject);
                                     })
                                 }, onReject)
                                 .then(function()
                                 {
                                     var patch = {
                                         name: $scope.reportControls.name,
                                         saveInProgress: false,
                                         publish: !asDraft,
                                         versionNote: comment || null
                                     };
                                     return $scope.saveSchedules(result.data._embedded.complexObject)
                                         .then(function()
                                         {
                                             return $http.patch('/api/reports/' + $scope.report.id, patch, {
                                                 noErrorPopup: true
                                             });
                                         });
                                 }, onReject)
                                 .then(function(result)
								 {
									 primeNGHelpersService.ajsSuccessfulSaveToast('Report');
									 
                                     $location.search('report', undefined)
										 .search('draft', result.data._embedded.complexObject.id).replace();
									 
									 delete $scope.report.originalId;
									 $('#savingModal').modal('hide');
									 
									 $rootScope.$broadcast('reportMenuItemsUpdated');
									 
                                     return $scope.refreshReport();
                                 }, onReject)
                         })
                         .catch(function(error)
                         {
                             $('#savingModal').modal('hide');
                             $('#failureSaveModal').modal({}, 'show');
                             if (!isNaN(parseInt($scope.report.originalId)))
                                 $scope.report.id = $scope.report.originalId;
                         })
                 })
     };

     $scope.reportMapping = reportMapping;
     $scope.selectedLog = $rootScope.selectedLog;

     $('.report-editor-container').on('change input', ':input:not(.select-rule)', function() {
         $scope.updateChangeStatus(true);
     });
     
     $scope.getReportSchedules = function(complexId)
     {
         complexId = complexId || ($scope.report.complexObject) ? $scope.report.complexObject.id : null;
         if (!complexId) return $q.resolve();
         return $http.get('/api/scheduledReports', {
             params: {
                 report: complexId
             }
         })
             .then(function(results)
             {
                 results = results.data._embedded.scheduledReports;
                 $scope.schedulers = results;
                 
                 return results;
             })
     }
     
     $scope.addSchedule = function(scheduleType)
     {
         $scope.updateChangeStatus(true);
         $scope.schedulers.splice(0, 0, { report: $scope.report.complexObject, type: scheduleType });
     }
     
     $scope.scheduleBound = function(schScope)
     {
         schScope.userSelect.promise().then(userSelector => {
             userSelector.addOnUserSelectedListener(() =>  $scope.updateChangeStatus(true));
         });
         
         schScope.userSelect.onUsersRemoved.push(() => $scope.updateChangeStatus(true));
         
         schScope.scheduler.cronSchedulerDefer.promise.then(() =>
         {
             schScope.scheduler.onChangeEvents.push(() => {
                 $scope.updateChangeStatus(true);
             })
         });
     }
     
     $scope.schedulersSavable = () =>
         $scope.schedulers.findIndex(schScope => !schScope.deleted && !!schScope.hasCronError) === -1;
     
     $scope.schedulersReady = () =>
         $scope.schedulers.reduce((value, schScope) => {
             return value && schScope.ready
         }, true);
     
     $scope.$watch(function(){ return $rootScope.selectedLog }, function(newVal)
     {
         if (newVal && $scope.currentLog && newVal.id !== $scope.currentLog.id) {
             // Redirect to report-manager on log change
             $location.url('/report-manager');
         }
         else if (newVal && newVal.hasOwnProperty('id'))
             $scope.currentLog = newVal;
     });
     
     $scope.$on('$includeContentLoaded', function (event)
     {
         $builder = loadReportBuilder($scope, $q, $location, $rootScope, $http, reportBuilderService, logService);

         $('#show-obsolete').click(function(e)
         {
             var showObsolete = $scope.reportControls.showObsoleteSegments = $(this).is(':checked');
             if ($scope.templateSegments)
             {
                 var obsoletes = $scope.filterFromSubTemplate($scope.templateSegments, $scope.subTemplate)
	                 .filter(function(segment) { return segment.obsolete })
                     .map(function(segment) { return Object.assign({}, segment, { name: segment.longName + ' (Removed)' }) });
                 
                 if (showObsolete)
                 {
                     obsoletes.forEach(function(segment) { $scope.lowerOutputGridOptions.data.push(segment) });
                 }
                 else
                 {
                    for (var i = $scope.lowerOutputGridOptions.data.length - 1; i >= 0; i--)
                    {
                        var segment = $scope.lowerOutputGridOptions.data[i];
                        if (obsoletes.find(function(obSegment) { return obSegment.id == segment.id }))
                        {
                            $scope.lowerOutputGridOptions.data.splice(i, 1);
                        }
                    }
                 }
             }
         });
     });
     
     $scope.$on('helpOpening', function($event, help)
     {
         try {
             const index = parseInt($('li.uib-tab.active[index]').attr('index'));
             switch (index)
             {
                 case 1:
                     help.setSection('report-output', 9);
                     break;
                 case 2:
                     help.setSection('report-access', 9);
                     break;
                 case 3:
                     help.setSection('schedule', 9);
                     break;
             }
         } catch(e)
         {
             console.error(e);
         }
     });
          
    // templatesInUse[] will have zero or more elements for the Default (All Notes) report template and 1 element only for a dedicated report template
    $scope.updateTemplatesInUse = function(templatesInUse) {
        console.log(templatesInUse);
    }

     $scope.$on('$destroy', function()
     {
         $builder.off();
         $(window).off('beforeunload');
     });
  }]);